import CollapsibleSection from './CreativeBriefs.CollapsibleSection';
import type {
  CBFilterHandlers,
  CBFilterOptions,
  CBFilterState,
  SortDirection
} from './CreativeBriefs.types';
import { SORT_DIRECTION } from './CreativeBriefs.types';
import {
  FilterCheckboxInput,
  FilterCheckboxLabel,
  FilterCheckboxRow,
  FilterPanel,
  FilterPanelHeader,
  FilterPanelTitle,
  FilterResetBtn,
  FilterSectionSort,
  FilterSectionSortLabel,
  FilterSectionSortSelect,
  VisibilityToggleInput,
  VisibilityToggleLabel,
  VisibilityToggleRow
} from './styles/filterPanel.styles';

type FilterSidebarProps = {
  filterState: CBFilterState;
  filterOptions: CBFilterOptions;
  handlers: CBFilterHandlers;
};

const FilterSidebar = ({ filterState, filterOptions, handlers }: FilterSidebarProps) => (
  <FilterPanel>
    <FilterPanelHeader>
      <FilterPanelTitle>Filter</FilterPanelTitle>
      <FilterResetBtn type="button" onClick={handlers.resetFilters}>
        Reset
      </FilterResetBtn>
    </FilterPanelHeader>

    <VisibilityToggleRow>
      <VisibilityToggleLabel htmlFor="visibilityToggle">
        Visible to customer only
      </VisibilityToggleLabel>
      <VisibilityToggleInput
        id="visibilityToggle"
        type="checkbox"
        checked={filterState.visibleToCustomerOnly}
        onChange={e => handlers.setVisibleToCustomerOnly(e.target.checked)}
      />
    </VisibilityToggleRow>

    <CollapsibleSection title="Creative Strategy">
      {filterOptions.strategies.map(({ strategyId, strategyName, count }) => (
        <FilterCheckboxRow key={strategyId}>
          <FilterCheckboxInput
            id={`strategy-${strategyId}`}
            type="checkbox"
            checked={filterState.selectedStrategyIds.includes(strategyId)}
            onChange={() => handlers.toggleStrategyId(strategyId)}
          />
          <FilterCheckboxLabel htmlFor={`strategy-${strategyId}`}>
            {strategyName} ({count})
          </FilterCheckboxLabel>
        </FilterCheckboxRow>
      ))}
    </CollapsibleSection>

    <CollapsibleSection title="Product">
      {filterOptions.products.map(({ productId, productName, count }) => (
        <FilterCheckboxRow key={productId}>
          <FilterCheckboxInput
            id={`product-${productId}`}
            type="checkbox"
            checked={filterState.selectedProductIds.includes(productId)}
            onChange={() => handlers.toggleProductId(productId)}
          />
          <FilterCheckboxLabel htmlFor={`product-${productId}`}>
            {productName} ({count})
          </FilterCheckboxLabel>
        </FilterCheckboxRow>
      ))}
    </CollapsibleSection>

    <CollapsibleSection title="Format">
      {filterOptions.formats.map(({ format, count }) => (
        <FilterCheckboxRow key={format}>
          <FilterCheckboxInput
            id={`format-${format}`}
            type="checkbox"
            checked={filterState.selectedFormats.includes(format)}
            onChange={() => handlers.toggleFormat(format)}
          />
          <FilterCheckboxLabel htmlFor={`format-${format}`}>
            {format} ({count})
          </FilterCheckboxLabel>
        </FilterCheckboxRow>
      ))}
    </CollapsibleSection>

    <CollapsibleSection title="Month">
      {filterOptions.months.map(({ month, count }) => (
        <FilterCheckboxRow key={month}>
          <FilterCheckboxInput
            id={`month-${month}`}
            type="checkbox"
            checked={filterState.selectedMonths.includes(month)}
            onChange={() => handlers.toggleMonth(month)}
          />
          <FilterCheckboxLabel htmlFor={`month-${month}`}>
            {month} ({count})
          </FilterCheckboxLabel>
        </FilterCheckboxRow>
      ))}
    </CollapsibleSection>

    <FilterSectionSort>
      <FilterSectionSortLabel htmlFor="sortFilter">Sort By</FilterSectionSortLabel>
      <FilterSectionSortSelect
        id="sortFilter"
        value={filterState.sortDirection}
        onChange={e => handlers.setSortDirection(e.target.value as SortDirection)}
      >
        <option value={SORT_DIRECTION.Desc}>Newest First</option>
        <option value={SORT_DIRECTION.Asc}>Oldest First</option>
      </FilterSectionSortSelect>
    </FilterSectionSort>
  </FilterPanel>
);

export default FilterSidebar;
